import { Link } from 'react-router-dom'
import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import Footer from '../components/Footer'

export default function TermsOfService() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2">
              <img 
                src="/branding/cte-course-platform-icon.svg" 
                alt="CTE Course Platform" 
                className="h-8 w-8"
              />
              <span className="text-2xl font-bold bg-gradient-to-r from-cte-blue to-cte-blue-dark bg-clip-text text-transparent">
                CTE Course Platform
              </span>
            </Link>
            <div className="flex items-center space-x-4">
              <Link
                to="/login"
                className="text-sm text-gray-600 hover:text-cte-blue transition-colors"
              >
                Sign In
              </Link>
              <Link
                to="/#pricing"
                className="text-sm bg-cte-blue text-white px-4 py-2 rounded-lg hover:bg-cte-blue-dark transition-colors"
              >
                Enroll Now
              </Link>
            </div>
          </div>
        </div>
      </header>

      <div className="flex-1 max-w-4xl mx-auto py-8 px-4 w-full bg-white my-8 rounded-lg shadow-sm">
      <Link
        to="/"
        className="inline-flex items-center text-cte-blue hover:text-cte-blue-dark mb-6"
      >
        <ArrowLeftIcon className="w-4 h-4 mr-2" />
        Back to Home
      </Link>

      <h1 className="text-4xl font-bold text-cte-black mb-4">Terms of Service</h1>
      <p className="text-gray-600 mb-8">
        <strong>Effective Date:</strong> November 2025<br />
        <strong>Last Updated:</strong> November 14, 2025<br />
        <strong>Company:</strong> CTE Consultants & General Sales LLC
      </p>

      <div className="prose prose-slate max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-cte-black mb-4">1. Acceptance of Terms</h2>
          <p className="text-gray-700 mb-4">
            By accessing and using the CTE Course Platform ("Platform"), you accept and agree to be bound by the terms and provision of this agreement.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-cte-black mb-4">2. Use License</h2>
          <p className="text-gray-700 mb-4">
            Permission is granted to access and use the Platform for personal, non-commercial educational purposes. This license shall automatically terminate if you violate any of these restrictions.
          </p>
          <p className="text-gray-700 mb-2">You agree NOT to:</p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose</li>
            <li>Attempt to decompile or reverse engineer any software</li>
            <li>Remove any copyright or proprietary notations</li>
            <li>Transfer the materials to another person or "mirror" on any other server</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-cte-black mb-4">3. User Accounts</h2>
          <p className="text-gray-700 mb-4">
            When you create an account with us, you must provide accurate, complete, and current information. Failure to do so constitutes a breach of the Terms.
          </p>
          <p className="text-gray-700 mb-4">
            You are responsible for safeguarding the password and for all activities that occur under your account.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-cte-black mb-4">4. Course Content</h2>
          <p className="text-gray-700 mb-4">
            All course materials, including but not limited to videos, documents, quizzes, and assignments, are the intellectual property of the Platform and are protected by copyright laws.
          </p>
          <p className="text-gray-700 mb-4">
            Students are granted a limited, non-exclusive, non-transferable license to access and view the course materials solely for personal educational use.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-cte-black mb-4">5. Student Code of Conduct</h2>
          <p className="text-gray-700 mb-2">Students agree to:</p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Complete assignments and assessments honestly and without plagiarism</li>
            <li>Respect instructors and fellow students</li>
            <li>Not share course materials without permission</li>
            <li>Not engage in any disruptive behavior</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-cte-black mb-4">6. Certificates</h2>
          <p className="text-gray-700 mb-4">
            Upon successful completion of course requirements, students may receive a certificate of completion. Certificates are issued at the discretion of the Platform and may be revoked if violations of these Terms are discovered.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-cte-black mb-4">7. Disclaimer</h2>
          <p className="text-gray-700 mb-4">
            The materials on the Platform are provided on an 'as is' basis. The Platform makes no warranties, expressed or implied, and hereby disclaims all other warranties including, without limitation, implied warranties of merchantability, fitness for a particular purpose, or non-infringement.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-cte-black mb-4">8. Limitations</h2>
          <p className="text-gray-700 mb-4">
            In no event shall the Platform or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the Platform.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-cte-black mb-4">9. Modifications</h2>
          <p className="text-gray-700 mb-4">
            The Platform may revise these Terms at any time without notice. By using this Platform you are agreeing to be bound by the then current version of these Terms.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-cte-black mb-4">10. Contact Information</h2>
          <p className="text-gray-700 mb-4">
            If you have any questions about these Terms, please contact us at:
          </p>
          <p className="text-gray-700">
            Email: <a href="mailto:techsupport@cteconsultants.net" className="text-cte-blue hover:underline">techsupport@cteconsultants.net</a>
          </p>
        </section>
      </div>
      </div>
      
      {/* Footer */}
      <Footer />
    </div>
  )
}
